import { render, staticRenderFns } from "./newLogin.vue?vue&type=template&id=c9289be6&scoped=true&"
import script from "./newLogin.vue?vue&type=script&lang=js&"
export * from "./newLogin.vue?vue&type=script&lang=js&"
import style0 from "./newLogin.vue?vue&type=style&index=0&id=c9289be6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9289be6",
  null
  
)

export default component.exports